import TextCarousel from '././components/TextCarousel';
import excellence  from 'assets/img/dashboards/excellence.png';
import access  from 'assets/img/dashboards/access.png';
import efficiency  from 'assets/img/dashboards/efficiency.png';
import efficacy  from 'assets/img/dashboards/efficacy.png';
import experience  from 'assets/img/dashboards/experience.png';
import results from 'assets/img/dashboards/results.png';
import TestimonialSlider from './variables/testimonial-slider';

    function Dashboard() {
      const slides = [
        { title: 'Welcome to Apex Learning Solutions', description: 'We offers a range of educational services, including tutoring, workshops, and online courses, designed to support students in achieving their academic goals.' },
        { title: 'Key Features', description: ' We offers key features such as personalized learning plans, interactive tutorials, and real-time progress tracking, providing students with a comprehensive and supportive educational environment.' },
        { title: 'Get Started Today', description: 'Get started today and discover a world of educational resources, expert instructors, and interactive courses designed to help you achieve your goals. Explore our programs now and take the first step towards a brighter future.' },
      ];

      return (
        <div className="App p-1">
          <h1 className="text-2xl font-bold text-center mb-8">Our  Highlights</h1>
          <TextCarousel slides={slides} />


         <div className=" mx-auto mt-3 p-2 bg-white shadow-lg rounded-lg">
     <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-5">
          <div className="p-4 bg-gray-100 content-start gap-4 flex flex-col items-center justify-center">
            <img src={excellence} alt='excellence'  className='h-16 w-16 object-cover rounded items-center'/>
              <div className='flex flex-col content-center text-center mt-2'>
                  <strong className='text-blue-800 text-lg'>Excellence</strong>
                  <span className='text-gray-700'>Empowering students with transferable skills, such as critical thinking and problem-solving,
                    enables them to excel academically and thrive in the workforce, fostering a lifelong pursuit of knowledge and success.</span>
                </div>
          </div>


      <div className="p-4 bg-gray-100 content-start gap-4 flex flex-col items-center justify-center">
            <img src={access} alt='excellence'  className='h-16 w-16 object-cover rounded items-center'/>
              <div className='flex flex-col content-center text-center mt-2'>
                  <strong className='text-blue-800 text-lg'>Access</strong>
                  <span className='text-gray-700'>Provides a supportive environment for students to achieve academic success. Resources include tutoring, 
                    study spaces, and technology access, fostering independent learning and collaboration.</span>
                </div>
          </div>

      <div className="p-4 bg-gray-100 content-start gap-4 flex flex-col items-center justify-center">
            <img src={efficiency} alt='excellence'  className='h-16 w-16 object-cover rounded items-center'/>
              <div className='flex flex-col content-center text-center mt-2'>
                  <strong className='text-blue-800 text-lg'>Efficiency</strong>
                  <span className='text-gray-700'> We prioritize efficiency to drive academic excellence. By streamlining resources, 
                    students can focus on achieving their goals, optimizing study time and improving retention.</span>
                </div>
          </div>

        <div className="p-4 bg-gray-100 content-start gap-4 flex flex-col items-center justify-center">
            <img src={efficacy} alt='excellence'  className='h-16 w-16 object-cover rounded items-center'/>
              <div className='flex flex-col content-center text-center mt-2'>
                  <strong className='text-blue-800 text-lg'>Efficacy</strong>
                  <span className='text-gray-700'>Providing tailored support to enhance academic outcomes. By offering personalized guidance and interactive tools, 
                    it fosters a conducive learning environment, empowering students to reach their full potential</span>
                </div>
          </div>   

          <div className="p-4 bg-gray-100 content-start gap-4 flex flex-col items-center justify-center">
            <img src={experience} alt='excellence'  className='h-16 w-16 object-cover rounded items-center'/>
              <div className='flex flex-col content-center text-center mt-2'>
                  <strong className='text-blue-800 text-lg'>Experience</strong>
                  <span className='text-gray-700'>At our institution, we pride ourselves on providing exceptional educational experiences. Our expert instructors deliver tailored guidance, 
                    empowering students to reach their full potential and thrive in their academic pursuits.</span>
                </div>
          </div> 

    </div>
    </div>
   <div className=" mx-auto mt-3 p-2 bg-white shadow-lg rounded-lg">
   <div className={` ${window.innerWidth > 1200 ? 'grid gap-2  bg-gray-100 grid-cols-[60%_30%]' : 'grid gap-2  bg-gray-100 grid-cols-[100%]'}`}>
     <div className="p-4  content-start ">
       <div className="p-4 ">
         <h2 className="text-xl font-semibold text-blue-800 mb-4">Our Personalized Tutoring Guarantee™</h2>
         <h3 className="text-gray-700 mb-3">With our Personalized Tutoring programs, we guarantee:</h3>
          <ul className="list-none space-y-2">
            <li className="text-gray-700 flex items-center">
              <svg className="h-5 w-5 text-green-600 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className='text-gray-700 font-medium'>Our team will get to know your child to put together an education program that’s unique to their needs.</span></li>
            <li className="text-gray-700 flex items-center">
              <svg className="h-5 w-5 text-green-600 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className='text-gray-700 font-medium'>We will provide regular progress updates and adjust the program as needed to ensure your child's success.</span></li>
            <li className="text-gray-700 flex items-center">
              <svg className="h-5 w-5 text-green-600 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className='text-gray-700 font-medium'>Our tutors are committed to creating a positive and engaging learning environment.</span>
            </li>
            <li className="text-gray-700 flex items-center">
              <svg className="h-5 w-5 text-green-600 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
             </svg>
              <span className='text-gray-700 font-medium'>
              If you're not satisfied with your child's progress, we'll work with you to make it right.</span>
            </li>
            <li className="text-gray-700 flex items-center">
              <svg className="h-5 w-5 text-green-600 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
             </svg>
              <span className='text-gray-700 font-medium'>We will provide a safe and supportive space for your child to learn and grow.</span>
            </li>
            <li className="text-gray-700 flex items-center">
              <svg className="h-5 w-5 text-green-600 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className='text-gray-700 font-medium'>Our tutors are experienced and qualified to provide high-quality instruction.</span>
           </li>
         </ul>
      </div>
     </div>
      <div className="flex items-center justify-center p-4 bg-gray-100 ">
        {window.innerWidth > 1200 ? <img src={results} alt='results'  className='h-36 w-36 bg-gray-100 bg-cover rounded-lg bg-gray-100 ' />
         : ''}
      </div>
    </div>
     </div>
         {/*
     Testimonial Section   */}
     <div className=" mx-auto mt-3 p-2 bg-white shadow-lg rounded-lg">
      <div className="p-4 ">
        <TestimonialSlider />
     </div>
    </div>
  </div>
 
  );
}

export default Dashboard;